import { Icon } from '@zenid/web';
import { css } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';

// TODO: アイコン下部にも下線を引く(やり方を模索する)
export function DeleteAccount() {
  return (
    <div
      className={flex({
        gap: '{spacing.10}',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: '{spacing.12}',
      })}
    >
      <Icon name="navigate_next" color="colors.text.link" size="s" />
      <a
        href="https://help.zenid.jp/hc/ja/articles/39066399291417"
        className={css({
          color: '{colors.text.link}',
          textDecoration: 'underline',
          textStyle: 'body.s.default',
          sm: {
            textStyle: 'body.m.default',
          },
        })}
      >
        ZEN IDのアカウント削除について
      </a>
    </div>
  );
}
